export default {"src":"/_next/static/media/pin-up.d2200a8c.svg","height":833,"width":1993,"blurWidth":0,"blurHeight":0};